import { createComponent } from '@carvana/merch-components';
import React from 'react';

export const FieldSet = createComponent('fieldset', {
  className: `
    relative
    mr-8
    w-[129px]
    rounded
    border
    border-solid
    border-grey-2
    bg-white
    p-0
    outline-none
    focus-within:border-blue-6
  `
});

export const Input = createComponent<React.HTMLProps<HTMLInputElement>>(
  'input',
  {
    className: `
    peer
    absolute
    left-0
    box-border
    block
    w-full
    min-w-0
    overflow-visible
    border-none
    bg-transparent
    px-0
    pb-[7px]
    pt-[22px]
    indent-16
    text-base
    placeholder-transparent
    outline-none
    tl-body-m
    placeholder:text-grey-3
    focus:!text-blue-6
  `
  }
);

export const Label = createComponent('label', {
  className: `
    absolute
    left-16
    top-[2px]
    z-0
    mb-[8px]
    block
    origin-top-left
    translate-x-0
    translate-y-[11px]
    scale-[0.63]
    transform
    p-0
    text-[13px]
    font-bold
    uppercase
    leading-[13px]
    text-blue-2
    transition
    delay-[0]
    duration-200
    ease-out
    peer-placeholder-shown:translate-x-0
    peer-placeholder-shown:translate-y-[19px]
    peer-placeholder-shown:scale-100
    peer-placeholder-shown:text-grey-2
    peer-focus:translate-x-0
    peer-focus:translate-y-[11px]
    peer-focus:scale-[0.63]
    peer-focus:text-blue-2
  `
});

export const Button = createComponent('button', {
  className: `
    h-56
    w-[100px]
    rounded
    border-0
    bg-blue-2
    font-bold
    uppercase
    leading-none
    text-white
    hover:bg-blue-3
    disabled:text-grey-5
  `
});
